































































































































import Vue from "vue";
import { DateFilterItems } from "../../types";
export default Vue.extend({
  props: {
    title: {
      type: String
    },
    page: {
      type: Number
    },
    pagelength: {
      type: Number
    },
    pagecount: {
      type: Number
    },
    columns: {
      type: Array
    },
    allcolumns: {
      type: Array
    },
    isDateFilterRequired: {
      type: Boolean,
      default: false
    },
    datefilter: {
      type: Object
    }
  },
  data(): { [key: string]: any } {
    return {
      isSortByOpen: false,
      isPageLengthOpen: false,
      isPageOpen: false,
      isDateFilterOpen: false
      // dateFilterSelected: {}
    };
  },
  inject: ["actionHandler"],
  methods: {
    addColumnToTable(column: string) {
      this.$emit("addColumnToView", column);
    },
    removeColumnFromTable(column: string) {
      this.$emit("removeColumnFromView", column);
    },
    resetColumnOrderInTable(columns: any[]) {
      this.$emit("resetSelectseqInView", columns);
    },
    updateView() {
      this.$emit("saveCurrentView");
    },
    resetView() {
      this.$emit("resetCurrentView");
    },
    setSortOrder() {
      this.$emit("setSortOrderInView");
    },
    goToPage(event: { item: { name: string; displayName: string } }) {
      this.isPageOpen = false;
      this.actionHandler("goToPage", event.item.name);
    },
    pageDecrease() {
      this.isPageOpen = false;
      this.actionHandler("pageDecrease", this.page - 1);
    },
    pageIncrease() {
      this.isPageOpen = false;
      this.actionHandler("pageIncrease", this.page + 1);
    },
    setPageLength(event: { item: { name: string; displayName: string } }) {
      this.isPageLengthOpen = false;
      this.actionHandler("setPageLength", event.item.name);
    },
    setDateFilter(event: {
      item: {
        name: string;
        displayName: string;
        selected: boolean;
      };
    }) {
      this.actionHandler("setDateFilter", event.item);
      if (event.item.name === "show_all") {
        this.isDateFilterOpen = false;
      }
    },
    customYearPredictor(
      customizedDate: Date,
      selectedDate: Date | null = null
    ) {
      if (
        selectedDate &&
        selectedDate.getFullYear()! == customizedDate.getFullYear()
      ) {
        return true;
      } else return false;
    },
    isStartDateDisabled(currentDateObject: Date) {
      //allow all dates
      return false;
    },
    isEndDateDisabled(currentDateObject: Date) {
      //disable all dates before startdate if any
      if (this.datefilter.start_date) {
        if (
          currentDateObject.getTime() <
          new Date(this.datefilter.start_date).getTime()
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setStartDate(date: Date) {
      if (
        this.datefilterStartDate &&
        this.datefilterEndDate &&
        this.datefilterEndDate.getTime() < this.datefilterStartDate.getTime()
      ) {
        this.actionHandler(
          "setDateFilter",
          Object.assign({}, this.datefilter, { end_date: null })
        );
      }
      this.actionHandler(
        "setDateFilter",
        Object.assign({}, this.datefilter, { start_date: date })
      );
    },
    setEndDate(date: Date) {
      this.actionHandler(
        "setDateFilter",
        Object.assign({}, this.datefilter, { end_date: date })
      );
    },
    cancelFilter() {
      this.isDateFilterOpen = false;
    },
    applyDateFilter() {
      this.actionHandler("applyDateFilter", this.datefilter);
      this.isDateFilterOpen = false;
    }
  },
  computed: {
    dateFilterItems() {
      return DateFilterItems.map(filter => {
        return {
          name: filter.name,
          displayName: filter.displayName,
          selected: filter.name === this.datefilter.name ? true : false
        };
      });
    },
    pagelengthItems() {
      return [10, 25, 50, 100].map(length => {
        return {
          name: length,
          displayName: length.toString(),
          selected: length === this.pagelength ? true : false
        };
      });
    },
    pageNumbers() {
      return new Array(this.pagecount).fill(0).map((page, i) => {
        return {
          name: i + 1,
          displayName: (i + 1).toString(),
          selected: this.page === i + 1 ? true : false
        };
      });
    },
    datefilterStartDate() {
      return this.datefilter.start_date
        ? new Date(this.datefilter.start_date)
        : null;
    },
    datefilterEndDate() {
      return this.datefilter.end_date
        ? new Date(this.datefilter.end_date)
        : null;
    }
  }
});
